import { useNavigate } from "react-router-dom"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow"
import styles from './Roles.module.scss'

const Roles = () => {

  const navigate = useNavigate()

  const statsData = [
    { title: "Total Roles".toUpperCase(), value: 0 },
    { title: "Total Permissions".toUpperCase(), value: 0 },
  ]

  const tableData = [
    { roleID: '001', role: 'Super Admin', desc: 'The Super Admin has unrestricted access to all sections, including managing roles, permissions, and platform-wide settings.', permissions: '001' },
    { roleID: '001', role: 'Admin', desc: 'Admins have broad access but with limited control over certain settings like Platform Settings, Security & Compliance, and User Management.', permissions: '001' },
    { roleID: '001', role: 'Supports Manager', desc: 'Handles sections related to Support & Communication, including Messages, Support Tickets, and FAQs.', permissions: '001' },
    { roleID: '001', role: 'Product Manager', desc: 'Manages Product Management sections, including Product Overview, Category Management, Inventory Management, and Product Approval Queue.', permissions: '001' },
    { roleID: '001', role: 'Finance Manager', desc: 'Responsible for Pricing, Finance & Payment, including managing Transactions, Payouts, Shipping & Delivery, and Revenue & Commission.', permissions: '001' },
    { roleID: '001', role: 'Marketing Manager', desc: 'Responsible for overseeing Marketing & Promotions, Advertisement, and Social Media Marketing, along with analytics reports related to marketing campaigns.', permissions: '001' },
    { roleID: '001', role: 'User Manager', desc: 'Handles User Management sections like Sellers, Wholesalers, Retailers, Admins, and Customer Wallet.', permissions: '001' },
    { roleID: '001', role: 'Store Manager', desc: 'Manages Store Management sections, including Seller Stores, Brand Stores, and Store Performance.', permissions: '001' },
    { roleID: '001', role: 'Content Manager', desc: 'Oversees Content Management including Gallery & Media, Blog & Articles, and Training Resources.', permissions: '001' },
  ]

  const columns = [
    {
      name: 'Role ID',
      selector: row => row.roleID,
      // sortable: true,
      grow: 0.5
    },
    {
      name: 'Role',
      selector: row => row.role,
      // sortable: true,

    },
    {
      name: 'Description',
      selector: row => row.desc,
      // sortable: true,
      wrap: true,
      grow: 2
    },
    {
      name: 'Permissions',
      selector: row => row.permissions,
      // sortable: true,
    },
    {
      name: 'Actions',
      cell: () => <div className="d-flex flex-column flex-lg-row align-items-center gap-2">
        <button className={styles['btn']}>View</button>
        <button className={styles['btn']}>Edit</button>
        <button className={styles['btn']}>Delete</button>
      </div>,
    }
  ];
  

  return (
    <>
      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="fw-semibold fs-5 mb-2">Overview</div>
        <DynamicCardRow cards={statsData} />
      </div>

      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="fw-semibold fs-5">Admin Management Roles</div>
          <DynamicButton theme="blue" onClick={() => navigate('/user-management/admins/add-new-role')}>
            Add new
          </DynamicButton>
        </div>
      </div>
      <DynamicDatatable data={tableData} columns={columns} type='yellow' />
    </>
  )
}

export default Roles